
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoajantaellora() {



    const cardData =
    {
        keyword: 'Pune To Ajanta Ellora Cab',
        heading: 'Mauli Cabs: Pune To Ajanta Ellora Cab',
        headingDescription: 'Mauli Cabs offers comfortable and reliable Pune to Ajanta Ellora cab services, ensuring a smooth and enjoyable journey to these UNESCO World Heritage sites. Whether you are traveling for a cultural exploration, a family trip, or a historical adventure, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs guarantees a hassle-free ride from Pune to Ajanta Ellora.',

        top: 'Top Places to Visit in Ajanta Ellora with Mauli Cabs',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "Ajanta Caves, located near Aurangabad, are a UNESCO World Heritage Site and a remarkable example of ancient Indian rock-cut architecture. These caves contain exquisite murals and sculptures that depict the life of Lord Buddha and other religious stories."
    },
    {
        "title": "Ellora Caves",
        "description": "Ellora Caves, also a UNESCO World Heritage Site, are famous for their stunning rock-cut temples and monasteries. The caves, with intricate carvings and sculptures, represent a blend of Hindu, Buddhist, and Jain religious art and architecture."
    },
    {
        "title": "Kailasa Temple (Ellora)",
        "description": "The Kailasa Temple in Ellora is a magnificent monolithic structure and one of the largest rock-cut temples in the world. The temple is dedicated to Lord Shiva and is known for its grandeur and intricate carvings."
    },
    {
        "title": "Cave 16 (Ajanta Caves)",
        "description": "Cave 16 in Ajanta is one of the most famous caves, known for its impressive murals and sculptures depicting the life and teachings of Buddha. The artwork here is considered some of the best in ancient Indian history."
    },
    {
        "title": "Buddha Statue (Ajanta Caves)",
        "description": "Ajanta's Cave 4 houses one of the most iconic Buddha statues, representing his meditative posture. The caves' art and sculptures are famous for their exceptional detail and religious significance."
    },
    {
        "title": "Chhota Kailasa (Ellora)",
        "description": "Chhota Kailasa, a small replica of the grand Kailasa Temple, is located in Ellora and is known for its architectural beauty. Though smaller, it holds great historical and artistic importance."
    },
    {
        "title": "Cave 1 (Ajanta Caves)",
        "description": "Cave 1 at Ajanta is known for its large Buddha statue and beautiful frescoes depicting Jataka tales. The paintings here are well-preserved and offer a glimpse into the religious life of ancient India."
    },
    {
        "title": "Aurangabad Caves",
        "description": "Located near Aurangabad, the Aurangabad Caves are lesser-known but equally beautiful rock-cut caves that offer a peaceful atmosphere and a glimpse into ancient Indian monastic life."
    },
    {
        "title": "Daultabad Fort (near Ellora)",
        "description": "Daultabad Fort, located near Ellora, is a historic fort with great architectural significance. It provides panoramic views of the surrounding landscape and offers an exciting experience for history enthusiasts."
    },
    {
        "title": "Grishneshwar Temple (Ellora)",
        "description": "Grishneshwar Temple, near Ellora, is one of the 12 Jyotirlinga shrines dedicated to Lord Shiva. The temple is a significant pilgrimage destination and an important part of the region’s religious heritage."
    }
],

"services": [
    {
        "name": "Pune to Alibaug Affordable Cab Service",
        "description": "Mauli Cabs offers affordable and reliable cab services from Pune to Alibaug. Enjoy a comfortable journey to this beautiful coastal destination with our well-maintained vehicles."
    },
    {
        "name": "Book Affordable Pune to Alibaug Taxi",
        "description": "Book an affordable taxi from Pune to Alibaug with Mauli Cabs. Get a stress-free ride with professional drivers and a range of vehicle options to suit your needs."
    },
    {
        "name": "Private Taxi for Alibaug from Pune",
        "description": "Travel privately to Alibaug from Pune with Mauli Cabs. Our private taxis offer flexibility, comfort, and the convenience of personal travel for your trip."
    },
    {
        "name": "Alibaug Trip by Cab from Pune",
        "description": "Planning a trip to Alibaug? Mauli Cabs provides convenient and comfortable cab services to make your journey from Pune smooth and hassle-free."
    },
    {
        "name": "Pune to Alibaug One-Way or Round Trip",
        "description": "Mauli Cabs offers both one-way and round-trip options for your Pune to Alibaug journey. Choose the option that best fits your schedule and travel preferences."
    },
    {
        "name": "Comfortable Taxi Ride to Alibaug",
        "description": "Enjoy a comfortable taxi ride from Pune to Alibaug with Mauli Cabs. Our vehicles are well-maintained, air-conditioned, and driven by professional drivers."
    },
    {
        "name": "Alibaug Sightseeing by Cab",
        "description": "Explore Alibaug with Mauli Cabs' sightseeing services. Visit popular spots like Alibaug Beach, Kolaba Fort, and more with a professional driver who knows the best routes."
    },
    {
        "name": "Group Travel to Alibaug",
        "description": "Mauli Cabs offers spacious vehicles for group travel to Alibaug. Whether you're traveling with family or friends, we ensure a comfortable and enjoyable journey for all."
    },
    {
        "name": "Luxury Taxi for Alibaug Trip",
        "description": "Travel to Alibaug in style with Mauli Cabs' luxury taxi services. Enjoy premium comfort, excellent service, and an unforgettable travel experience."
    },
    {
        "name": "Alibaug Holiday by Private Taxi",
        "description": "Plan your Alibaug holiday with Mauli Cabs' private taxi service. Enjoy a personalized and stress-free travel experience with flexible scheduling and customized options."
    }
],

"tableData": [
    ["Pune to Alibaug Affordable Cab Service", "Book Affordable Pune to Alibaug Taxi"],
    ["Private Taxi for Alibaug from Pune", "Alibaug Trip by Cab from Pune"],
    ["Pune to Alibaug One-Way or Round Trip", "Comfortable Taxi Ride to Alibaug"],
    ["Alibaug Sightseeing by Cab", "Group Travel to Alibaug"],
    ["Luxury Taxi for Alibaug Trip", "Alibaug Holiday by Private Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs provides reliable and punctual service for your Pune to Ajanta Ellora trip. Our drivers ensure timely pickups and drop-offs, helping you reach these historical and cultural sites without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a wide range of comfortable vehicles for your Pune to Ajanta Ellora journey, including sedans, SUVs, and premium cars. All vehicles are air-conditioned, spacious, and designed for a comfortable ride, ensuring a pleasant journey across the scenic route."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the Pune to Ajanta Ellora route, ensuring a smooth, safe, and comfortable journey. They know the best routes and driving conditions to make your trip as efficient as possible."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive pricing for your Pune to Ajanta Ellora trip with no hidden charges. We ensure transparent pricing, providing you with the best value for your money and a stress-free travel experience."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols to ensure a secure journey to the Ajanta and Ellora caves."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Ajanta Ellora trip. Whether you're planning an early morning departure or a late-night return, our customer service team is always ready to assist you with your booking."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Ajanta Ellora cab with Mauli Cabs is quick and easy. You can book your ride online via our website or mobile app, or contact our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Ajanta Ellora trip. Whether you're visiting for a day trip or a more leisurely tour, we can tailor your journey to fit your preferences and schedule."
    }
]













    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Ajanta Ellora with Mauli Cabs?',
            answer: 'Booking a cab for the Ajanta Ellora tour is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Ajanta Ellora as your destination, then select the vehicle that suits your comfort and needs. Alternatively, you can call our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Ajanta Ellora trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your trip, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose the vehicle based on your comfort and group size for the trip to Ajanta Ellora.',
        },
        {
            question: 'Is the fare for the Pune to Ajanta Ellora trip fixed?',
            answer: 'Yes, the fare for the trip is fixed and transparent. It includes tolls, taxes, and driver charges, so there are no hidden costs. You will know the total fare upfront before confirming your booking.',
        },
        {
            question: 'How long does the journey from Pune to Ajanta Ellora take?',
            answer: 'The journey from Pune to Ajanta Ellora typically takes around 5 to 6 hours, depending on traffic and road conditions. Our drivers ensure a smooth and comfortable ride for you throughout the journey.',
        },
        {
            question: 'Are the drivers experienced with the Pune to Ajanta Ellora route?',
            answer: 'Yes, all Mauli Cabs drivers are experienced with the Pune to Ajanta Ellora route and are familiar with the best roads to take, ensuring a safe and pleasant journey to the caves.',
        },
        {
            question: 'Can I book a round trip from Pune to Ajanta Ellora?',
            answer: 'Yes, you can easily book a round trip to Ajanta Ellora. Just provide your return details when booking, and we will take care of the rest.',
        },
        {
            question: 'Can I make stops for sightseeing along the way to Ajanta Ellora?',
            answer: 'Yes, you can customize your journey to include sightseeing stops along the way. Our drivers can take you to nearby attractions or allow you to take breaks during your trip to make it more enjoyable.',
        },
        {
            question: 'Are the cabs air-conditioned and comfortable?',
            answer: 'Yes, all our cabs are fully air-conditioned and well-maintained for your comfort and cleanliness. We ensure a pleasant ride with ample space and comfort for your trip to Ajanta Ellora.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy via our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Ajanta Ellora trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicle options, professional drivers, and flexible itineraries. We ensure a comfortable, stress-free, and memorable experience on your trip to Ajanta Ellora.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Arun Jadhav",
            position: "History Enthusiast",
            text: "Our trip to Ajanta Ellora was amazing! The cab was comfortable, the driver was very knowledgeable about the route, and the caves were breathtaking. Mauli Cabs made the journey smooth and enjoyable from start to finish.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Shweta Rao",
            position: "Cultural Traveler",
            text: "I had a fantastic experience with Mauli Cabs. The trip to Ajanta Ellora was comfortable, and the driver was courteous and professional. The caves were spectacular, and the overall trip was one of a kind. Highly recommended for anyone looking to visit!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Ajanta Ellora Cab by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and comfortable cab services from Pune to Ajanta Ellora. Book private, luxury, or group taxis for a smooth and scenic journey to the famous Ajanta and Ellora Caves. Enjoy one-way or round-trip options with 24x7 online booking support.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "4800"
        }
      };
      
     
      


    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Ajanta Ellora Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a comfortable and affordable cab from Pune to Ajanta Ellora with Mauli Cabs. Choose from private, luxury, or group taxis for one-way or round-trip travel. Enjoy a hassle-free sightseeing trip to the UNESCO World Heritage sites."
        />
        <meta
          name="keywords"
          content="Pune to Ajanta Ellora cab service, Book Pune to Ajanta Ellora taxi, Affordable Pune to Ajanta Ellora cab, Private taxi for Ajanta Ellora from Pune, Ajanta Ellora trip by cab from Pune, Pune to Ajanta Ellora one-way or round trip, Comfortable taxi ride to Ajanta Ellora, Group travel to Ajanta Ellora, Luxury cab for Ajanta Ellora tour, Pune to Ajanta Ellora sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoajantaellora;